import {Message} from "@2d-front-monorepo/design-library";
import {JSX} from "react";

export default function InvalidPermitId({permitId}:{permitId:string | undefined}): JSX.Element {
	return <Message title={{text: `Invalid permit id: [${permitId}]`}} type="error"/>;
}
